




import { Component, Vue } from 'vue-property-decorator';
import LeafletsModlue from '@/store/modules/leaflets';

@Component
export default class Leaflets extends Vue {
  // 上層画像のURL
  private url = LeafletsModlue.url;

  // ストアアクションの購読解除関数
  private unsubscribe?: Function;

  activated() {
    this.changeIndex();

    // モジュール監視
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'leaflets/setPage') {
        this.changeIndex();
      }
    });

    LeafletsModlue.play();
  }

  deactivated() {
    this.unsubscribe && this.unsubscribe();
    LeafletsModlue.stop();
  }

  /**
   * チラシのインデックスが更新されたときにURLを適応
   */
  private changeIndex() {
    this.url = LeafletsModlue.url;
    this.$forceUpdate();
  }
}
